module.exports = require("core-js-pure/stable/number/is-finite");


//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/node_modules/@babel/runtime-corejs3/core-js-stable/number/is-finite.js
// module id = 1345
// module chunks = 44